import { CreateThemeAITaskRequest, ThemeAITask } from '../../types/gotypes'

// "Use this set-up on other data" (#1492 item 9). Adam, 23 Sep: "you can run
// that same one just on either a different variable or a CSV ... the actual
// configuration of all those other steps and the themes that you've picked".
// What a task stores of its set-up is its pinned code frame version and its
// task context, so that is what carries over. The data does not: the user
// picks new data, and the result is a new task. The original is untouched.
//
// Labels are deliberately left behind: they describe the old data (file
// names, variables), not the set-up.

export type ReusableSetup = Pick<CreateThemeAITaskRequest, 'code_frame_id' | 'code_frame_version' | 'study_context'>

export const reuseSetupFrom = (task: ThemeAITask): ReusableSetup => ({
  code_frame_id: task.code_frame_id || undefined,
  code_frame_version: task.code_frame_id ? task.code_frame_version : undefined,
  study_context: task.study_context?.trim() || undefined,
})

/** A task with neither a code frame nor a task context has nothing to reuse. */
export const hasReusableSetup = (task: ThemeAITask): boolean =>
  Boolean(task.code_frame_id || task.study_context?.trim())

export const suggestedReuseName = (task: ThemeAITask): string => `${task.name} (new data)`

/** The control that reuses a task's set-up: a colleague's task is copied this way. */
export const REUSE_LABEL = 'Use this set-up on other data'

/** The copy offer in a "you can't change this task" reason, naming that control. */
export const REUSE_COPY = `“${REUSE_LABEL}”`
